<template>
  <div v-if="onOpenOrClosedImageWindow" class="popup-overlay">
    <div class="popup">
      <CloseButton :onClicked="closeImageWindowEvent" />
      <h2 class="textStyle">{{ $t("chooseImage") }}</h2>
      <ul class="image-list" v-if="computedImages && computedImages.length > 0">
        <button
          v-for="image in computedImages"
          v-bind:key="image.id"
          v-bind:class="{ selImg: image.sel }"
          class="image-btn"
          @click="chooseImage(image)"
        >
          <li>
            <img :src="image.url" />
          </li>
        </button>
      </ul>

      <h5 v-else>{{ $t("noImages") }}</h5>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import CloseButton from "../../common/buttons/CloseButton.vue";

export default {
  name: "InstructionImageWindow",
  components: { CloseButton },
  props: {
    images: {
      default: [],
    },
  },

  data() {
    return {};
  },

  computed: {
    ...mapGetters({
      onOpenOrClosedImageWindow:
        "instructionImages/onImageWindowOpenedOrClosed",
      onSelectedImage: "instructionImages/onSelectedImage",
    }),
    computedImages: {
      get() {
        const images = this.images;
        console.table(images);
        const currentImage = this.onSelectedImage;
        console.table(currentImage);

        images.forEach((image) => {
          console.log(image);
          if (currentImage !== null && image.id === currentImage.id)
            image.sel = true;
          else image.sel = false;
        });

        return images;
      },
    },
  },

  methods: {
    ...mapActions({
      closeImageWindowEvent: "instructionImages/closeWindowEvent",
      selectedImageEvent: "instructionImages/selectedImageEvent",
    }),
    chooseImage(image) {
      this.selectedImageEvent(image);
      this.closeImageWindowEvent();
    },
  },
};
</script>

<style scoped>
/* Popup Overlay */
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 11;
}

/* Popup Box */
.popup {
  background: white;
  padding: 20px;
  border-radius: 10px;
  text-align: center;
  width: 70vw;
  height: 90vh;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  z-index: 12;
}

.image-list {
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* 3 equal columns */
  gap: 5vw; /* Space between images */
  max-height: 80%; /* Limit height to viewport */
  overflow-y: auto; /* Enable scrolling if needed */
  list-style: none; /* Remove default bullet points */
  padding: 20px;
  margin: 0;
}

.image-list img {
  width: 100%; /* Make images fill their grid cell */
  height: auto; /* Maintain aspect ratio */
  object-fit: cover; /* Crop if necessary */
}

.image-list li {
  width: 100%; /* Spacing between images */
}

.image-btn {
  background-color: white;
  padding: 10px;
  border-radius: 5%;
  border-style: none;
  border-color: rgba(0, 0, 0, 0.3);
  box-shadow: -1px 1px 5px 0px rgba(0, 0, 0, 0.6);
}

.image-btn:hover {
  box-shadow: -1px 1px 5px 0px var(--flow-main-color);
}

.selImg {
  border-style: solid;
  border-color: var(--flow-main-color);
  border-width: 3px;
}

.textStyle {
  color: var(--flow-main-color);
  font-weight: bold;
}
</style>
